export enum ComponentId {
  OWNER_TYPE = "type",
}
